import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsImportData from './SettingsImportData';

function DataPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Data"
        subtitle="Import, export, and AI configuration"
        backTo="/settings-landing"
        backLabel="Settings"
        sticky
      />
      <div className="p-6">
        <SettingsImportData />
      </div>
    </div>
  );
}

export default DataPage;
